"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Abstraction of Material UI's `Paper` that defaults to the 
 * `outlined` variant and renders children within our `Flex`
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Paper = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Paper.default, {
    className: props.classNamePaper,
    elevation: props.variant === "outlined" ? undefined : props.elevation,
    square: props.square,
    sx: {
      paddingTop: props.py,
      paddingRight: props.px,
      paddingBottom: props.py,
      paddingLeft: props.px
    },
    variant: props.variant,
    ...props.PaperProps,
    children: props.children
  });
};
Paper.propTypes = {
  PaperProps: _propTypes.default.object,
  classNamePaper: _propTypes.default.string,
  elevation: _propTypes.default.number,
  px: _propTypes.default.number,
  py: _propTypes.default.number,
  square: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(["outlined", "elevation"])
};
Paper.defaultProps = {
  elevation: 0,
  px: 1,
  py: 1,
  square: false,
  variant: "outlined"
};
var _default = exports.default = Paper;